module.exports = __webpack_public_path__ + "static/media/Hero-Brain 1.4f080f2a.svg";